export default __webpack_public_path__ + "static/media/download.7db6226c.webp";